import { AppService } from 'st-common/App/Services/AppService';
import { CommonTypes } from 'st-common/App/CommonTypes';
import { ClientsSharedTypes } from './ClientsSharedTypes';

// Merge the shared type symbols with this module's type symbols
const Types = { 
    ...CommonTypes,
    Clients: {
        ApiClients: {
            ...ClientsSharedTypes.ApiClients,
        },
        Services: {
            ...ClientsSharedTypes.Services
        }
    }
};

export { AppService, Types }